import { styled } from "@mui/material/styles";
import { Chain } from "chainConfigs";
import { Circle, Row } from "v2/components/base/Flex/ui";
import WEthIcon from "assets/icons/tokens/weth.avif";
import SolanaIcon from "assets/icons/chains/solana.png";
import EthereumIcon from "assets/icons/chains/ethereum.png";
import TonIcon from "assets/icons/chains/ton.png";
import BaseIcon from "assets/icons/chains/base.png";
import BeraIcon from "assets/icons/chains/bera.png";
import BscIcon from "assets/icons/chains/bsc.png";
import HyperLiquidIcon from "assets/icons/chains/hype.png";
import TronIcon from "assets/icons/chains/tron.png";
import AptosIcon from "assets/icons/chains/apt.png";
import SuiIcon from "assets/icons/chains/sui.png";
import LineaIcon from "assets/icons/chains/linea.png";
import SonicIcon from "assets/icons/chains/sonic.png";
import AbstractIcon from "assets/icons/chains/abstract.png";
import FantomIcon from "assets/icons/chains/ftm.png";
import PolygonIcon from "assets/icons/chains/matic.png";
import OptimismIcon from "assets/icons/chains/op.png";
import ArbitrumIcon from "assets/icons/chains/arb.png";
import AvalancheIcon from "assets/icons/chains/avax.png";

export const CHAIN_BADGE_MAP: Record<string, string> = {
  solana: SolanaIcon,
  ethereum: EthereumIcon,
  ton: TonIcon,
  base: BaseIcon,
  berachain: BeraIcon,
  bsc: BscIcon,
  hyperliquid: HyperLiquidIcon,
  hype: HyperLiquidIcon,
  tron: TronIcon,
  aptos: AptosIcon,
  sui: SuiIcon,
  linea: LineaIcon,
  sonic: SonicIcon,
  abstract: AbstractIcon,
  fantom: FantomIcon,
  ftm: FantomIcon,
  polygon: PolygonIcon,
  matic: PolygonIcon,
  optimism: OptimismIcon,
  op: OptimismIcon,
  arbitrum: ArbitrumIcon,
  arb: ArbitrumIcon,
  avax: AvalancheIcon,
  avalanche: AvalancheIcon,
};

const ChainBadge = styled("img")<{ size: "sm" | "md" }>(({ theme, size }) => ({
  position: "absolute",
  top: size === "sm" ? theme.spacing(-0.1) : theme.spacing(-0.5),
  right: size === "sm" ? theme.spacing(-0.5) : theme.spacing(-0.5),
  width: size === "sm" ? theme.spacing(2) : theme.spacing(3),
  height: size === "sm" ? theme.spacing(2) : theme.spacing(3),
}));

const CoinAvatar = ({
  size,
  iconUri,
  chain,
  badgeSize,
  badgeProps,
  ...props
}: {
  size: number;
  iconUri: string;
  chain: Chain;
  badgeSize: number;
  badgeProps: any;
} & any) => {
  const { sx, ...rest } = props;
  return (
    <Row
      type="cc"
      sx={{
        position: "relative",
        width: `${size}px`,
        height: `${size}px`,
        ...sx,
      }}
      {...rest}>
      <Circle.Image
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
        }}
        size={size}
        src={iconUri}
      />
      {chain && (
        <Circle.Image
          sx={{
            position: "absolute",
            top: "0%",
            right: "0%",
            transform: "translateX(25%) translateY(0)",
            border: "1px solid #FFFFFF",
          }}
          size={badgeSize}
          src={CHAIN_BADGE_MAP[chain]}
          alt={chain}
          {...badgeProps}
        />
      )}
    </Row>
  );
};

export default CoinAvatar;
